import {
    Chip,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Typography,
    Button,
    Tabs,
    Tab,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import axios from 'axios';
import b64toBlob from 'b64-to-blob';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../reducers';
import { parentUrl } from '../../../../utils/constants';
import { dateFormatter } from '../../../../utils/timeFormat';
import { getRequestType } from '../../../../store/request.slice';
import WidgetLoading from '../../Shared/WidgetLoading';
import { Request } from '../../../../Models/Requests/Request.model';
import { IRequestQuestionType } from '../../../Requests/interfaces';
import { REQUEST_API } from '../../../../store/requests.slice';
import { fetchMemberPromisesByTeam, exportMemberPromisesByTeam } from '../../../Widgets/WidgetService';
import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';
import { StatusEnum } from '../../../../Enum/StatusEnum';
import { useNavigate } from 'react-router';
import { useWidgetContext } from '../../../../hooks/widgetContext';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAppDispatch } from '../../../../store/store';
import { RequestTimeFilterEnum } from '../../../../Enum/RequestTimeFilterEnum';
import { copyObject } from '../../../../utils/common';

type mappedRequestQuestionTypeOption = {
    value: string;
    label: string;
    subRequestTypes?: IRequestQuestionType[];
    isNotEncounterable?: boolean;
    Zcode: string;
};

const MemberPromisesByTeamDetail = () => {
    const history = useNavigate();
    const dispatch = useAppDispatch();
    const { activeProviders } = useSelector((state: RootState) => state.provider);
    const { careTeams: teams } = useSelector((state: RootState) => state.careTeams);
    const [requestTypeOptions, setRequestTypeOptions] = useState<mappedRequestQuestionTypeOption[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const timePeriods = [
        { label: RequestTimeFilterEnum.From0To30DaysDescription, value: RequestTimeFilterEnum.From0To30Days },
        { label: RequestTimeFilterEnum.From31To60DaysDescription, value: RequestTimeFilterEnum.From31To60Days },
        { label: RequestTimeFilterEnum.Above60DaysDescription, value: RequestTimeFilterEnum.Above60Days },
        { label: RequestTimeFilterEnum.CustomDescription, value: RequestTimeFilterEnum.Custom },
    ];
    const [downLoading, setDownLoading] = useState<boolean>(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const copyProviders = copyObject(activeProviders);
    const {
        memberPromisesSelectedTeam,
        setMemberPromisesSelectedTeam,
        memberPromisesShowInActiveTeams,
        setMemberPromisesShowInActiveTeams,
        memberPromisesSelectedProvider,
        setMemberPromisesSelectedProvider,
        memberPromisesShowInActiveProviders,
        setMemberPromisesShowInActiveProviders,
        memberPromisesRequestType,
        setMemberPromisesRequestType,
        memberPromisesFilterBy,
        setMemberPromisesFilterBy,
        memberPromisesTab,
        setMemberPromisesTab,
        memberPromisesFromDate,
        setMemberPromisesFromDate,
        memberPromisesToDate,
        setMemberPromisesToDate,
    } = useWidgetContext();

    const filteredProviders = (memberPromisesShowInActiveProviders ? copyProviders : copyProviders.filter((p) => p.Role.RoleName !== 'Inactive')) || [];
    const filteredTeams = memberPromisesShowInActiveTeams ? teams : teams.filter(t => !t.IsDeleted);

    const fetchRequestTypeOptions = async () => {
        const deprecatedTypes = ['Others'];
        const response = await axios.get(`${REQUEST_API}/GetRequestTypesList`);
        if (response?.data) {
            const requestTypes: mappedRequestQuestionTypeOption[] = (response.data as IRequestQuestionType[])
                .map(({ Id, RequestTypeLabel, ZCode: Zcode, SubRequestTypes, IsNotEncounterable }) => {
                    return {
                        value: Id,
                        subRequestTypes: SubRequestTypes,
                        label: RequestTypeLabel,
                        isNotEncounterable: IsNotEncounterable,
                        Zcode: Zcode,
                    };
                })
                .filter(({ label }) => !deprecatedTypes.includes(label))
                .sort((a, b) => a.label.localeCompare(b.label));
            setRequestTypeOptions(requestTypes);
        }
    };

    useEffect(() => {
        const changeFilter = async () => {

            if (memberPromisesFilterBy !== RequestTimeFilterEnum.Custom || (Boolean(memberPromisesFromDate) && Boolean(memberPromisesToDate))) {
                setIsLoading(true);
                const changeFilter = async () => {
                    setIsLoading(true);
                    let dateFrom = Boolean(memberPromisesFromDate) && memberPromisesFilterBy === RequestTimeFilterEnum.Custom ? new Date(memberPromisesFromDate).toISOString() : '';
                    let dateTo = Boolean(memberPromisesToDate) && memberPromisesFilterBy === RequestTimeFilterEnum.Custom ? new Date(memberPromisesToDate).toISOString() : '';
                    const response = await fetchMemberPromisesByTeam(memberPromisesRequestType, memberPromisesFilterBy, memberPromisesSelectedTeam, memberPromisesSelectedProvider, memberPromisesShowInActiveTeams, memberPromisesShowInActiveProviders, dateFrom, dateTo);
                    setRows(response);
                    let filterResponse = [];
                    switch (memberPromisesTab) {
                        case 1: {
                            filterResponse = response.filter(r => r.Status === StatusEnum.New || r.Status === StatusEnum.InProgress);
                            break;
                        }
                        case 2: {
                            filterResponse = response.filter(r => r.Status !== StatusEnum.New && r.Status !== StatusEnum.InProgress && r.Status !== StatusEnum.Archived);
                            break;
                        }
                    }
                    setFilteredRows(filterResponse);
                    setIsLoading(false);
                };
                changeFilter();
            }

            if (memberPromisesFilterBy !== RequestTimeFilterEnum.Custom && Boolean(memberPromisesFromDate) && Boolean(memberPromisesToDate)) {
                setMemberPromisesFromDate(null);
                setMemberPromisesToDate(null);
            }
        };
        changeFilter();
    }, [memberPromisesSelectedTeam, memberPromisesRequestType, memberPromisesFilterBy, memberPromisesShowInActiveTeams, memberPromisesFromDate, memberPromisesToDate, memberPromisesSelectedProvider, memberPromisesShowInActiveProviders]);

    useEffect(() => {
        dispatch(getRequestType());
    }, [dispatch]);

    useEffect(() => {
        fetchRequestTypeOptions();
    }, []);

    const getRequestTypeLabel = (request: Request) => {
        if (request?.SubRequestTypeLabel?.length > 0) return request.SubRequestTypeLabel;
        if (request?.RequestTypeLabel?.length > 0) return request.RequestTypeLabel;
        return Boolean(request?.Type) ? request.Type : 'Unknown Request Type';
    };

    const exportDetail = async () => {
        setDownLoading(true);
        let dateFrom = Boolean(memberPromisesFromDate) && memberPromisesFilterBy === RequestTimeFilterEnum.Custom ? new Date(memberPromisesFromDate).toISOString() : '';
        let dateTo = Boolean(memberPromisesToDate) && memberPromisesFilterBy === RequestTimeFilterEnum.Custom ? new Date(memberPromisesToDate).toISOString() : '';
        const response = await exportMemberPromisesByTeam(memberPromisesRequestType, memberPromisesFilterBy, memberPromisesSelectedTeam, memberPromisesSelectedProvider, memberPromisesShowInActiveTeams, memberPromisesShowInActiveProviders, dateFrom, dateTo);
        let blob = b64toBlob(response.base64String, 'text/csv');
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        var date = new Date();
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        var dateInfo = [(mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd, date.getFullYear()].join('');
        link.setAttribute('download', `MemberPromisesByTeam - ${dateInfo}.xlsx`);
        link.click();
        link.remove();
        setDownLoading(false);
    };

    const backToWidget = () => {
        history('/provider/metricsummary/smart-dashboard');
    };

    const stripHtml = (html: string) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        return temp.textContent || temp.innerText || '';
    };

    const columns: GridColDef[] = [
        {
            field: 'AhcccsId',
            headerName: 'AHCCCS ID',
            flex: 1,
            renderCell: (params) => {
                let member = Boolean(params.row.AhcccsId) ? params.row.AhcccsId : '-';
                return <>{member}</>;
            },
        },
        {
            field: 'RequestFor',
            headerName: 'Member',
            flex: 1,
            renderCell: (params) => {
                let member = Boolean(params.row.RequestFor?.Name) ? params.row.RequestFor?.Name : '-';
                return <>{member}</>;
            },
        },
        {
            field: 'Type',
            headerName: 'Type',
            flex: 1,
            renderCell: (params) => {
                return <>{getRequestTypeLabel(params.row)}</>;
            },
        },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                return <>{<Chip
                    size="small"
                    variant={'filled'}
                    color={
                        params.row.Status === 1 ? 'primary' :
                            params.row.Status === 2 ? 'warning' :
                                params.row.Status === 3 ? 'success' :
                                    params.row.Status === 4 ? 'default' :
                                        params.row.Status === 5 ? 'secondary' :
                                            'error'
                    }
                    label={
                        params.row.Status === 1 ? 'New' : params.row.Status === 2 ? 'In-Progress' :
                            params.row.Status === 3 ? 'Completed' : params.row.Status === 4 ? 'Archived' :
                                params.row.Status === 5 ? 'Closed With No Action' : 'Expired'
                    }
                />}</>;
            },
        },
        {
            field: 'RequestFrom',
            headerName: 'Originator',
            flex: 1,
            renderCell: (params) => {
                let member = Boolean(params.row.RequestFrom?.Name) ? params.row.RequestFrom?.Name : '-';
                return <>{member}</>;
            },
        },
        {
            field: 'RequestTo',
            headerName: 'Assigned To',
            flex: 1,
            renderCell: (params) => {
                let member = Boolean(params.row.RequestTo?.Name) ? params.row.RequestTo?.Name : '-';
                return <>{member}</>;
            },
        },
        {
            field: 'CreatedOn',
            headerName: 'Created Date',
            flex: 1,
            valueGetter: (value, row) => `${Boolean(row.CreatedOn) ? dateFormatter(new Date(row.CreatedOn)) : '-'}`,
        },
        {
            field: 'Priority',
            headerName: 'Priority',
            flex: 1,
            renderCell: (params) => {
                return <>{<Chip
                    size="small"
                    variant={'filled'}
                    color={params.row.Priority === 3 ? 'error' : params.row.Priority === 2 ? 'warning' : 'success'}
                    label={params.row.Priority === 3 ? 'HIGH' : params.row.Priority === 2 ? 'MEDIUM' : 'LOW'}
                />}</>;
            },
        },
        {
            field: 'Message',
            headerName: 'Message',
            valueGetter: (value, row) => stripHtml(row.Message),
            flex: 2,
        },
        {
            field: 'IsRequestTouched',
            headerName: 'Request Touched',
            flex: 1,
            valueGetter: (value, row) => `${Boolean(row.IsRequestTouched) ? 'Yes' : 'No'}`,
        },
        {
            field: 'LastUpdatedOn',
            headerName: 'Last Updated',
            flex: 1,
            valueGetter: (value, row) => `${Boolean(row.LastUpdatedOn) ? dateFormatter(new Date(row.LastUpdatedOn)) : '-'}`,
        },
        {
            field: 'LastSeen',
            headerName: 'Member Seen',
            flex: 1,
            valueGetter: (value, row) => `${Boolean(row.LastSeen) ? dateFormatter(new Date(row.LastSeen)) : '-'}`,
        },
    ];

    const handleAlertsTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        let filterResponse = [];
        switch (newValue) {
            case 1: {
                filterResponse = rows.filter(r => r.Status === StatusEnum.New || r.Status === StatusEnum.InProgress);
                break;
            }
            case 2: {
                filterResponse = rows.filter(r => r.Status !== StatusEnum.New && r.Status !== StatusEnum.InProgress && r.Status !== StatusEnum.Archived);
                break;
            }
        }
        setFilteredRows(filterResponse);
        setMemberPromisesTab(newValue);
    };

    const toggleInactiveHandler = (isChecked: boolean) => {
        setMemberPromisesShowInActiveProviders(isChecked);
        setMemberPromisesSelectedProvider('All');
        setMemberPromisesSelectedTeam("NotSelected");
    };

    const toggleInactiveTeamsHandler = (isChecked: boolean) => {
        setMemberPromisesShowInActiveTeams(isChecked);
        setMemberPromisesSelectedTeam('All');
        setMemberPromisesSelectedProvider("NotSelected");
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Paper elevation={5}>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2} paddingTop={1}>
                    <Grid size={12} paddingBottom={1}>
                        <span onClick={backToWidget}>
                            <ArrowBackIcon className="pointer mr-2" style={{ color: 'black' }} titleAccess="Back" />
                        </span>
                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                            Member Promises By Team ({rows?.length})
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2} paddingTop={1}>
                    <Grid size={1.8}>
                        <FormControl className="width-100p">
                            <InputLabel id="demo-simple-select-label">Provider</InputLabel>
                            <Select
                                value={memberPromisesSelectedProvider}
                                size="small"
                                label="Provider"
                                renderValue={(selected) => {
                                    if (selected === "NotSelected") {
                                        return <span style={{ color: "gray" }}>Not Selected</span>;
                                    }

                                    if (selected === "All") {
                                        return "All";
                                    }

                                    const provider = filteredProviders.find(p => p.Id === selected);
                                    return provider
                                        ? `${provider.LastName}, ${provider.FirstName}`
                                        : "";
                                }}
                                onChange={(e) => {
                                    const value = e.target.value as string;
                                    setMemberPromisesSelectedProvider(value);

                                    // reset Team to NotSelected
                                    if (value !== "NotSelected") {
                                        setMemberPromisesSelectedTeam("NotSelected");
                                    }
                                }}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
                            >
                                <MenuItem value="NotSelected" disabled sx={{ color: 'gray' }}>
                                    Not Selected
                                </MenuItem>
                                <MenuItem key="All" value="All">
                                    All
                                </MenuItem>
                                <FormControlLabel
                                    sx={{ pl: '12px', mb: '0px' }}
                                    control={<Checkbox checked={memberPromisesShowInActiveProviders}
                                        onChange={(e) => toggleInactiveHandler(e.target.checked)} />}
                                    label="Show Inactive"
                                />
                                {filteredProviders.map((provider) => {
                                    return (
                                        <MenuItem
                                            key={provider.Id}
                                            value={provider.Id}
                                            sx={{ color: provider.Role.RoleName === 'Inactive' ? 'grey' : 'black' }}
                                        >
                                            {provider.LastName + ', ' + provider.FirstName}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={1.8}>
                        <FormControl className="width-100p">
                            <InputLabel id="demo-simple-select-label">Team</InputLabel>
                            <Select
                                value={memberPromisesSelectedTeam}
                                size="small"
                                label="Team"
                                renderValue={(selected) => {
                                    if (selected === "NotSelected") {
                                        return <span style={{ color: "gray" }}>Not Selected</span>;
                                    }

                                    if (selected === "All") {
                                        return "All";
                                    }

                                    const team = filteredTeams.find(p => p.Id === selected);
                                    return team
                                        ? `${team.Name}`
                                        : "";
                                }}
                                onChange={(e) => {
                                    const value = e.target.value as string;
                                    setMemberPromisesSelectedTeam(value);

                                    // reset Provider to NotSelected
                                    if (value !== "NotSelected") {
                                        setMemberPromisesSelectedProvider("NotSelected");
                                    }
                                }}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
                            >
                                <MenuItem value="NotSelected" disabled sx={{ color: 'gray' }}>
                                    Not Selected
                                </MenuItem>
                                <MenuItem key="All" value="All">
                                    All
                                </MenuItem>
                                <FormControlLabel
                                    sx={{ pl: '12px', mb: '0px' }}
                                    control={<Checkbox checked={memberPromisesShowInActiveTeams} onChange={(e) => toggleInactiveTeamsHandler(e.target.checked)} />}
                                    label="Show Inactive"
                                />
                                {filteredTeams.map((team) => {
                                    return (
                                        <MenuItem
                                            key={team.Id}
                                            value={team.Id}
                                            sx={{ color: team.IsDeleted ? "gray" : "black" }}
                                        >
                                            {team.Name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={2}>
                        <FormControl className="width-100p">
                            <InputLabel id="demo-simple-select-label">Request Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                size="small"
                                value={memberPromisesRequestType || ''}
                                label="Request Type"
                                onChange={(e) => {
                                    setMemberPromisesRequestType(e.target.value);
                                }}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
                            >
                                <MenuItem value={'0'}>All</MenuItem>

                                {Object.entries(requestTypeOptions).map(([key, value]) => {
                                    return (
                                        <MenuItem key={key} value={value.value}>
                                            {`${value.label}`}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={1.5}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Date Filter</InputLabel>
                            <Select
                                value={memberPromisesFilterBy}
                                label="Date Filter"
                                name="Date"
                                fullWidth
                                onChange={(e) => setMemberPromisesFilterBy(parseInt(e.target.value as any))}
                            >
                                {timePeriods.map((date) => (
                                    <MenuItem key={date.value} value={date.value}>
                                        {date.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {memberPromisesFilterBy === RequestTimeFilterEnum.Custom ? (
                        <React.Fragment>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Grid size={1.5}>
                                    <DesktopDatePicker
                                        label="From Date"
                                        value={Boolean(memberPromisesFromDate) ? memberPromisesFromDate : null}
                                        minDate={new Date('2017-01-01')}
                                        onChange={(newValue) => setMemberPromisesFromDate(newValue)}
                                        slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                    />
                                </Grid>
                                <Grid size={1.5}>
                                    <DesktopDatePicker
                                        label="To Date"
                                        value={Boolean(memberPromisesToDate) ? memberPromisesToDate : null}
                                        minDate={new Date('2017-01-01')}
                                        onChange={(newValue) => setMemberPromisesToDate(newValue)}
                                        slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                    />
                                </Grid>
                            </LocalizationProvider>
                        </React.Fragment>
                    ) : (
                        <></>
                    )}
                    <Grid size={memberPromisesFilterBy === RequestTimeFilterEnum.Custom ? 0.7 : 3.7}></Grid>
                    <Grid size={1}>
                        <Button
                            style={{ minWidth: '120px', marginLeft: 'auto' }}
                            onClick={() => exportDetail()}
                            variant="contained"
                            color="success"
                            disabled={downLoading || rows?.length === 0}
                        >
                            {downLoading ? 'Exporting...' : 'Export'}
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2} paddingTop={3} paddingBottom={3}>
                    <Grid size={6} display="flex" justifyContent="flex-start">
                        <Tabs value={memberPromisesTab} onChange={handleAlertsTabChange}>
                            <Tab value={1} label="Open" />
                            <Tab value={2} label="Closed" />
                        </Tabs>
                    </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                    <Grid size={12}>
                        <div style={{ width: '100%', height: 'calc(100vh - 120px)', maxHeight: '500px', position: 'relative' }}>
                            {isLoading && <WidgetLoading />}
                            <Grid size={12} pt={1}>
                                <div style={{ width: '100%', height: 'calc(100vh - 100px)', maxHeight: '450px' }}>
                                    <DataGrid
                                        onCellClick={(params: any) => {
                                            window.open(`${parentUrl}provider/members-list/member-chart/${params.row.RequestFor.Id}/member-profile`, '_blank');
                                        }}
                                        rows={filteredRows}
                                        columns={columns}
                                        paginationModel={{ pageSize: pageSize, page: page }}
                                        onPaginationModelChange={(model) => {
                                            setPageSize(model.pageSize);
                                            setPage(model.page);
                                        }}
                                        pageSizeOptions={[5]}
                                        getRowId={(row) => row.Id}
                                        getRowHeight={() => 'auto'}
                                        sx={{
                                            [`& .${gridClasses.cell}`]: {
                                                py: 1,
                                            },
                                            [`& .green`]: {
                                                color: 'green',
                                            },
                                            [`& .red`]: {
                                                color: 'red',
                                            },
                                            [`& .black`]: {
                                                color: 'rgba(0,0,0,0.87)',
                                            },
                                        }}
                                    />
                                </div>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </LocalizationProvider>
    );
};

export default MemberPromisesByTeamDetail;